<template>
  <div
    v-if="row.editing && (userRole === 'Admin' || userRole === 'SuperAdmin')"
    class="form-group mb-0">
    <input
      v-model="row.effective_date"
      required
      class="form-control form-date w-100"
      type="date"
      :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']"
      pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
    <div class="invalid-tooltip">Please include the Date{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
  </div>
  <span v-else>{{ new Date(row.effective_date.replace(/-/g, '/')).toLocaleString('en-AU',{year: "numeric", month: "2-digit", day: "numeric"}) }}</span>
</template>

<script>
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'

export default {
  props: ['row'],
  mixins: [LEGACYBROWSERS],
  data() {
    return {
      userRole: localStorage.role
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Members/Tabs/MembershipHistoryFields/EffectiveDate.vue